/*
 * Genix Custom Checkout — drop-in theme script.
 *
 * Paste this file into your theme (assets/genix-checkout.js) and include it
 * from theme.liquid:
 *
 *   {{ 'genix-checkout.js' | asset_url | script_tag }}
 *
 * Or paste the whole file contents inside a <script> tag anywhere in
 * theme.liquid before </body>. It works either way.
 *
 * What it does:
 *   1. Intercepts every checkout button / form on the storefront and hands
 *      the buyer off to the Genix custom checkout with a valid cartId.
 *   2. On the buyer's return from the custom checkout (URL flag
 *      ?genix_order_placed=1), clears the theme cart and forwards them to
 *      the Shopify order-status page.
 *
 * No merchant configuration UI — set the app URL below, drop the file in,
 * done.
 */

(function () {
  // ============================================================
  // CONFIG — change this to your deployed checkout app URL.
  // ============================================================
  var CHECKOUT_APP_ORIGIN = 'https://genix-checkout.vercel.app';
  var DEBUG = false; // set true while testing to see console logs
  // ============================================================

  var origin = String(CHECKOUT_APP_ORIGIN || '').replace(/\/+$/, '');
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[genix]'].concat([].slice.call(arguments))); }
  function warn() { if (window.console) console.warn.apply(console, ['[genix]'].concat([].slice.call(arguments))); }

  if (!origin || !/^https?:\/\//i.test(origin)) {
    warn('CHECKOUT_APP_ORIGIN is not set — script is inactive');
    return;
  }

  // ---------- Return-from-checkout: clear cart, forward to order status ----------
  (function handleReturn() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('genix_order_placed') !== '1') return;

      var orderUrl = params.get('order_url') || '';
      var safeOrderUrl = /^https:\/\//i.test(orderUrl) ? orderUrl : '';

      params.delete('genix_order_placed');
      params.delete('order_url');
      var cleanUrl =
        window.location.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        window.location.hash;

      log('clearing theme cart after order');
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
        .catch(function () {})
        .finally(function () {
          if (safeOrderUrl) window.location.replace(safeOrderUrl);
          else window.history.replaceState({}, '', cleanUrl);
        });
    } catch (err) {
      warn('return handler error', err);
    }
  })();

  // ---------- Checkout hijack ----------
  var busy = false;

  async function startCustomCheckout(triggerEl) {
    if (busy) return;
    busy = true;

    var originalText = null;
    if (triggerEl && 'disabled' in triggerEl) {
      originalText = triggerEl.textContent;
      triggerEl.disabled = true;
      if (triggerEl.tagName === 'BUTTON') triggerEl.textContent = 'Loading…';
    }

    try {
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      var cart = await cartRes.json();

      if (!cart || !cart.items || !cart.items.length) {
        throw new Error('Your cart is empty.');
      }

      log('handing off', cart.items.length, 'lines');
      var res = await fetch(origin + '/api/cart-handoff', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cart: cart }),
      });
      var data = await res.json().catch(function () { return {}; });

      if (!data || !data.success || !data.checkoutUrl) {
        throw new Error((data && data.error) || 'Could not start checkout.');
      }

      window.location.href = data.checkoutUrl;
    } catch (err) {
      busy = false;
      warn('checkout failed', err);
      if (triggerEl && 'disabled' in triggerEl) {
        triggerEl.disabled = false;
        if (originalText !== null) triggerEl.textContent = originalText;
      }
      alert((err && err.message) || 'Could not start checkout. Please try again.');
    }
  }

  // Selectors for common checkout controls across themes.
  var BUTTON_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'button#cart-sidebar-checkout',
    'a#cart-sidebar-checkout',
    'button.button-checkout',
    'a.button-checkout',
    'button[data-checkout]',
    'a[data-checkout]',
    'a.cart__checkout',
    'button.cart__checkout',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
  ];

  function looksLikeCheckoutControl(el) {
    if (!el || !el.matches) return false;
    for (var i = 0; i < BUTTON_SELECTORS.length; i++) {
      try { if (el.matches(BUTTON_SELECTORS[i])) return true; } catch (e) {}
    }
    // Text heuristic — catches themes with custom class names.
    var txt = (el.textContent || '').trim().toLowerCase();
    if (txt === 'checkout' || txt === 'check out' || txt === 'proceed to checkout') return true;
    return false;
  }

  // Capture phase so we beat the theme's own click handlers.
  document.addEventListener('click', function (e) {
    var el = e.target;
    for (var hop = 0; el && hop < 6; hop++) {
      if (looksLikeCheckoutControl(el)) {
        e.preventDefault();
        e.stopPropagation();
        startCustomCheckout(el);
        return;
      }
      el = el.parentElement;
    }
  }, true);

  // Themes that submit <form action="/checkout"> instead of clicking a button.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    var isCheckoutForm =
      action === '/checkout' ||
      (action === '/cart' && form.querySelector('[name="checkout"]'));
    if (!isCheckoutForm) return;
    e.preventDefault();
    e.stopPropagation();
    startCustomCheckout(form.querySelector('[name="checkout"]') || null);
  }, true);

  // Strip inline onclick="window.location='/checkout'" if the theme uses them.
  function stripInlineOnclick(root) {
    (root || document).querySelectorAll('[onclick]').forEach(function (el) {
      var onclick = el.getAttribute('onclick') || '';
      if (/\/checkout/i.test(onclick)) el.removeAttribute('onclick');
    });
  }
  stripInlineOnclick();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) stripInlineOnclick(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  log('active — app origin:', origin);
})();
